import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { http, errText } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const done = useRef(false);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (done.current) return undefined;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    http.post("/auth/google/session", { session_id: sid })
      .then((r) => nav("/admin", { replace: true, state: { user: r.data } }))
      .catch((e) => setErr(errText(e)));
    return undefined;
  }, [location.hash, nav]);
  if (!err) return <div className="min-h-screen bg-[#154F49]" data-testid="auth-callback" />;
  return (
    <div className="min-h-screen bg-[#154F49] flex items-center justify-center p-4 font-sans">
      <div className="max-w-md w-full bg-[#FBF8F1] rounded-3xl p-8 space-y-4" role="alert" data-testid="google-auth-error">
        <h1 className="font-serif text-3xl text-[#154F49]">Google sign-in didn't work</h1>
        <p className="text-sm text-[#1A2E2B]">{err}</p>
        <a href="/admin/login" className="btn-primary">Back to staff login</a>
      </div>
    </div>
  );
}
